angular.module('qkr.finance1').config($routeSegmentProvider => {
  $routeSegmentProvider.options.autoLoadTemplates = true;

  $routeSegmentProvider
    .when('/finance1_data_upload', 'finance1DataUpload')
    .when('/finance1_inventory', 'finance1Inventory');

  $routeSegmentProvider.segment('finance1DataUpload', {
    controller: 'finance1Controller',
    controllerAs: 'vm',
    template: require('../../templates/accountancy/finance1/familynumber.html'),
    resolve: {
      lookupFinance1Response: [
        'lookupDataUploadService',
        function(lookupDataUploadService) {
          return lookupDataUploadService.loadLookupFinance1Info();
        }
      ],
      beneficiaryCustomFields: [
        'beneficiariesService',
        function(beneficiariesService) {
          return beneficiariesService.loadBeneficiaryCustomFields();
        }
      ]
    },
    untilResolved: { template: require('../../shared/loading-screen.html') },
    resolveFailed: { template: require('../../shared/loading-error.html') }
  }).segment('finance1Inventory', {
    controller: 'finance1CategoryController',
    controllerAs: 'vm',
    template: require('../../templates/accountancy/finance1/inventory.html'),
    resolve: {
      productList: [
        'inventoryService',
        function(inventoryService) {
          return inventoryService.loadInventory();
        }
      ],
      merchantInfo: [
        'merchantService',
        function(merchantService) {
          return merchantService.refreshMerchantInfo();
        }
      ]
    },
    untilResolved: { template: require('../../shared/loading-screen.html') },
    resolveFailed: { template: require('../../shared/loading-error.html') }
  });
});



// WEBPACK FOOTER //
// ./src/finance1/config/finance1.config.js